import { render, staticRenderFns } from "./LegendItemEnterprise.vue?vue&type=template&id=54f527d8&scoped=true"
import script from "./LegendItemEnterprise.vue?vue&type=script&lang=ts"
export * from "./LegendItemEnterprise.vue?vue&type=script&lang=ts"
import style0 from "./LegendItemEnterprise.vue?vue&type=style&index=0&id=54f527d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f527d8",
  null
  
)

export default component.exports